var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { selectPlayerLevelInfo } from "../balancingSelectors/selectBalancingXpLevels";
import { IdResource } from "../constants/IdResource";
import { utilTracking } from "../utils/tracking/utilTracking";
import { selectInventoryResourceInfo } from "./selectInventoryInfo";
import { selectPlayerInfo } from "./selectPlayerInfo";
export var selectFbConnectedServerAccount = function (state) {
    var accountConnected = state.facebookConnectInfo.serverConnectedPlayer;
    var xp = accountConnected.xp;
    var level = selectPlayerLevelInfo(accountConnected.level);
    var nextLevel = selectPlayerLevelInfo(accountConnected.level + 1);
    return {
        accountConnected: __assign({}, accountConnected, { lastLoginTime: accountConnected.lastLoginTime * 1000 }),
        level: level,
        nextLevel: nextLevel,
        xp: xp,
    };
};
export var selectFbConnectedWebAccount = function (state) {
    var _a = selectPlayerInfo(state), name = _a.name, playerId = _a.playerId;
    var amountGold = selectInventoryResourceInfo(state, IdResource.Gold).amount;
    var amountFarmDollars = selectInventoryResourceInfo(state, IdResource.Money).amount;
    var accountConnected = {
        amountFarmDollars: amountFarmDollars,
        amountGold: amountGold,
        id: playerId,
        lastLoginTime: utilTracking.getStartDateTime(),
        name: name,
    };
    return {
        accountConnected: accountConnected,
    };
};
export var selectPlayerFbConnected = function (state) {
    return state.facebookConnectInfo.fbConnected;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectFbConnectedAccountInfo.ts
// module id = 942
// module chunks = 3